import { useFetcher } from '../hooks/useFetcher';
import { useNavigate } from 'react-router-dom';
import AddHolder from '../components/AddHolder';
import Filter from '../components/Filter';
import ProductRow from '../components/Product-Row';
import { useEffect,useState } from 'react';


let cartMaxCount=10;
const Home = () => {
  const [homeData, loading] = useFetcher(`home`);
  const [banners] = useFetcher('')
  const navigate = useNavigate();
  const [currentTime,setCurrentTime]=useState(0);
 

  const onClick = (route) => {
    
    navigate(`/products/${route}`);
  };
  useEffect(() => {
    if (!localStorage.getItem('products')) {
      localStorage.setItem('products', JSON.stringify([]));
    }
  }, []);

  useEffect(() => {
  try{
    const interval=setInterval(() => {
        
      setCurrentTime(prevCount => (prevCount==2?0:prevCount+1));
      let imgs=document.querySelectorAll(".slider-image");
      let imgMobs=document.querySelectorAll(".slider-image-mob");
          if(imgs.length>0){
            imgs[currentTime==0?2:currentTime-1].animate([
              {opacity:'1'},
              {opacity:'0'}
            ],500);
            imgMobs[currentTime==0?2:currentTime-1].animate([
              {opacity:'1'},
              {opacity:'0'}
            ],500);
            setTimeout(() => {
              for (let i = 0; i < imgs.length; i++) {
              if(i!=currentTime)
                imgs[i].hidden=true;
                imgMobs[i].hidden=true;
              }
              imgs[currentTime].animate([
              {opacity:'0'},
              {opacity:'1'}
              ],500);
              imgMobs[currentTime].animate([
                {opacity:'0'},
                {opacity:'1'}
              ],500);
              imgs[currentTime].hidden=false;
              imgMobs[currentTime].hidden=false;
            }, 300);
          }
          
    }, 6000);
    return () => clearInterval(interval);
  }catch{}
  }, [currentTime]);

  if (loading) {
    return <div className='lds-dual-ring'></div>;
  }
  return (
    <main className="w-full h-fit overflow-hidden">
      <div className="slider-box md:hidden flex pt-5 px-2 flex items-start overflow-hidden">
        {banners && <>
          <img className='w-full slider-image-mob active' src={banners.adv[0].img}  alt="banner" />
          <img className='w-full slider-image-mob' src={banners.adv[1].img} hidden alt="banner" />
          <img className='w-full slider-image-mob' src={banners.adv[2].img} hidden alt="banner" />
        </>}
      </div>
      <div className=" slider-box hidden md:flex pt-5 px-2 flex items-start overflow-hidden">
        {banners && <>
        <img className='w-full slider-image active' src={banners.advweb[0].img} alt="banner" />
        <img className='w-full slider-image' src={banners.advweb[1].img} hidden alt="banner" />
        <img className='w-full slider-image' src={banners.advweb[2].img} hidden alt="banner" />
        </>}
      </div>


      {homeData && (
        <>

          {/* specials */}
          {homeData.specials && (
            <>
              <AddHolder />
              <Filter 
                callBack={onClick.bind(null, 'specials')} 
                title="فروش ویژه"
                sellTime={homeData.specials.expiration}
              />
              <ProductRow 
                callBack={onClick.bind(null, 'specials')} 
                products={homeData.specials.data} 
                banner={homeData.specials.banner} 
                webBanner={homeData.specials.web_banner}
                colorPrimary={homeData.specials.color_primary}
                sellTime={homeData.specials.expiration}
                 />
            </>
          )}

          {/* Latest */}
          {homeData.latest && (
            <>
              <AddHolder />
              <Filter
                callBack={onClick.bind(null, 'latest')}
                title="جدیدترین ها"
              />
              <ProductRow products={homeData.latest} />
            </>
          )}

          {/* Offers */}
          {homeData.offers && (
            <>
              <AddHolder />
              <Filter callBack={onClick.bind(null, 'offer')} 
              title="تخفیف ها" />
              <ProductRow products={homeData.offers} />
            </>
          )}

          {/* Best Sellers */}
          {homeData.bestSellers && (
            <>
              <AddHolder />
              <Filter
                callBack={onClick.bind(null, 'bestSeller')}
                title="پرفروش ها"
              />
              <ProductRow products={homeData.bestSellers} />
            </>
          )}

          
        </>
      )}
    </main>
  );
};

export default Home;
